var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84961 16.4825C4.84961 19.2769 8.65313 19.9999 13.1579 19.9999C17.6388 19.9999 21.4662 19.3026 21.4662 16.5081C21.4662 13.7137 17.6637 12.9907 13.1579 12.9907C8.67702 12.9907 4.84961 13.6891 4.84961 16.4825Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3475 17.2384C24.9487 16.8327 25.9994 16.0719 25.9994 14.7354C25.9994 12.4937 23.063 11.8517 19.4941 11.8069C19.5968 11.8412 19.6979 11.8768 19.7973 11.9138C20.7532 12.2694 21.6508 12.7838 22.3188 13.5498C23.0141 14.347 23.3997 15.3493 23.3997 16.515C23.3997 16.7638 23.382 17.0051 23.3475 17.2384Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88411 11.8042C6.79424 11.8342 6.70556 11.8652 6.61812 11.8973C5.66164 12.2481 4.7607 12.7575 4.08912 13.5199C3.38943 14.3143 3 15.3166 3 16.485C3 16.7768 3.02417 17.0584 3.07132 17.3291C1.23281 16.947 0 16.1661 0 14.7139C0 12.3943 3.1671 11.8083 6.88411 11.8042Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3011 9.52399C18.5534 9.56604 18.8129 9.58793 19.0778 9.58793C21.6214 9.58793 23.6593 7.57255 23.6593 5.0591C23.6593 2.54565 21.6214 0.530273 19.0778 0.530273C18.6925 0.530273 18.3188 0.576558 17.9619 0.663847C19.1315 1.85365 19.8491 3.48009 19.8491 5.2801C19.8491 6.89889 19.2687 8.3773 18.3011 9.52399Z",
    fill: "#8B8B8E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29102 5.31444C7.29102 2.36755 9.6861 0 12.6673 0C15.6494 0 18.0435 2.36767 18.0435 5.31444C18.0435 8.26121 15.6494 10.6289 12.6673 10.6289C9.6861 10.6289 7.29102 8.26133 7.29102 5.31444Z",
    fill: "#8B8B8E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72792 0.597601C6.35398 1.77917 5.50033 3.45208 5.50033 5.31428C5.50033 6.94878 6.15799 8.43747 7.2479 9.57606C7.14134 9.58328 7.03374 9.58695 6.92522 9.58695C4.38257 9.58695 2.34375 7.57157 2.34375 5.05813C2.34375 2.54468 4.38257 0.529297 6.92522 0.529297C7.1993 0.529297 7.46751 0.552698 7.72792 0.597601Z",
    fill: "#8B8B8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersActive);
export default __webpack_public_path__ + "static/media/usersActive.a8fd1a79db5b4f29ef5f1b7a68a7e25f.svg";
export { ForwardRef as ReactComponent };